import React, { createContext, useContext, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { sessionAliveNewToken } from '../../store/auth/sessionAlive/actions';
import { GET_COMPANY_FROM_URL, WITH_COMPANY_PATH } from '../../components/Common/CommonFunction';




const SessionContext = createContext();


const SESSION_TIMEOUT_DURATION = 28 * 60 * 1000;
const REFRESH_TOKEN_INTERVAL = 29 * 60 * 1000;


export const SessionProvider = ({ history, children }) => {
    const Company = GET_COMPANY_FROM_URL()

    // const history = useHistory();

    const dispatch = useDispatch();

    const [session, setSession] = useState({
        active: ((localStorage.getItem(`${Company}_token`)) && (localStorage.getItem(`${Company}_roleId`))) ? true : false,
        // ... other session data
    });




    const updateSessionActivity = (newSession = {}) => {
        setSession((prevSession) => ({
            ...prevSession,
            ...newSession,
        }));
    };


    const sessionEndActivity = ({
        sessionTimeout,
        refreshTokenIntervalId,
        resetSessionTimeout,
    }) => {

        window.removeEventListener('mousemove', resetSessionTimeout);
        window.removeEventListener('keydown', resetSessionTimeout);
        for (let key in localStorage) {
            if (
                key.startsWith(`${Company}_`) &&
                key !== `${Company}_companyCode` &&
                key !== `${Company}_companyTheme`
            ) {
                localStorage.removeItem(key);
            }
        }
        clearTimeout(sessionTimeout);
        clearInterval(refreshTokenIntervalId);
        updateSessionActivity({ active: false })
    }

    useEffect(() => {

        let sessionTimeout;
        let refreshTokenIntervalId;

        const startSessionTimeout = () => {
            localStorage.setItem(`${Company}_lastActivity`, Date.now())
            sessionTimeout = setTimeout(() => {
                if (!isUserActive(SESSION_TIMEOUT_DURATION)) {
                    sessionEndActivity({
                        sessionTimeout,
                        refreshTokenIntervalId,
                        resetSessionTimeout,
                        resetSessionTimeout
                    })

                }
            }, SESSION_TIMEOUT_DURATION);
        };

        const resetSessionTimeout = () => {
            if (session.active === true) {
                clearTimeout(sessionTimeout);
                startSessionTimeout();
            }
        };



        if (session.active === true) {
            window.addEventListener('mousemove', resetSessionTimeout);
            window.addEventListener('keydown', resetSessionTimeout);
            startSessionTimeout();

            if (islastToken()) {
                callRefreshToken(dispatch);
            } else {
                localStorage.setItem(`${Company}_lastRefreshToken`, Date.now());
            }

            refreshTokenIntervalId = setInterval(() => {
                
                callRefreshToken(dispatch);
            }, REFRESH_TOKEN_INTERVAL);
        }

        return () => {
            clearTimeout(sessionTimeout);
            clearInterval(refreshTokenIntervalId);
            window.removeEventListener('mousemove', resetSessionTimeout);
            window.removeEventListener('keydown', resetSessionTimeout);
        };
    }, [session.active]);



    useEffect(() => {


        const handleStorageChange = (event) => {
            if (event.key === `Logout`) {

            }

            if ((event.key === `Logout`) && (event.storageArea.Logout === (Company))) {
                window.location.href = WITH_COMPANY_PATH("/login");
            }
            if (event.key === `${Company}_LOGIN_REDIRECT`) {

                if (event.newValue) {

                    window.location.href = WITH_COMPANY_PATH(event.newValue);
                }
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };

    }, []);

    return (
        <SessionContext.Provider value={{ session, updateSessionActivity }}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => useContext(SessionContext);

const isUserActive = (SESSION_TIMEOUT_DURATION) => {
    const Company = GET_COMPANY_FROM_URL()
    const currentTime = Date.now();
    const timeElapsed = currentTime - localStorage.getItem(`${Company}_lastActivity`);
    return timeElapsed < SESSION_TIMEOUT_DURATION;
};
const islastToken = () => {
    const Company = GET_COMPANY_FROM_URL()
    const currentTime = Date.now();
    const timeElapsed = currentTime - localStorage.getItem(`${Company}_lastRefreshToken`);
    return timeElapsed < REFRESH_TOKEN_INTERVAL;
};

const callRefreshToken = (dispatch) => {
    
    const Company = GET_COMPANY_FROM_URL()
    let istoken = localStorage.getItem(`${Company}_refreshToken`)
    if (istoken) {
        localStorage.setItem(`${Company}_lastRefreshToken`, Date.now());
        let jsonBody = { "refresh": `${istoken}` }
        dispatch(sessionAliveNewToken(jsonBody))
    }
};